/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ImageAlbumIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Image Album',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <circle cx="26.5" cy="13.5" r="2.5" />
    <path
      d="M33 6H3a1 1 0 0 0-1 1v3H1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h1v8H1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h1v3a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1ZM6 25a1 1 0 0 1-1 1H4v-4h1a1 1 0 0 1 1 1Zm0-12a1 1 0 0 1-1 1H4v-4h1a1 1 0 0 1 1 1Zm26 12.748-4.519-4.519a1.713 1.713 0 0 0-2.424 0l-2.633 2.632-6.476-6.477a1.716 1.716 0 0 0-2.425 0L8 22.908V8h24Z"
    />
  </svg>`;
};
